export enum OrderStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  READY_FOR_SHIPMENT = 'ready-for-shipment',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  REFUNDED = 'refunded',
}

export const OrderStatusMap = {
  [OrderStatus.PENDING]: '待付款',
  [OrderStatus.PROCESSING]: '處理中',
  [OrderStatus.READY_FOR_SHIPMENT]: '揀貨中',
  [OrderStatus.COMPLETED]: '已出貨',
  [OrderStatus.CANCELLED]: '取消訂單',
  [OrderStatus.REFUNDED]: '已退費',
} as const
